import { useAuth } from "context/AuthContext";
import { useTooltip } from "context/TooltipProvider";
import InvestigationFileForm from "pages/InvestigationFileList/modal/InvestigationFileForm";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  editCrimeReferences,
  editCrimeReferences2,
  fetchFurtherInvestigationFromCRandIncidentRegNo,
  fetchInvestigationFileFromCRandIncidentRegNo,
} from "services/incidentService";
import {
  editFurtherInvestigation2,
  editReceivingInvestigationFile2,
} from "services/prosecutorPoliceService";
import {
  CrimeReference,
  FurtherInvestigation,
  Investigation,
  InvestigationFile,
  Roles,
} from "types";
import { CheckIcon, LoadingIcon } from "utils/constant";
import { errorHandler, errorHandlerOnForm, hasRole } from "utils/helper";

type Props = {
  incident: CrimeReference;
  investigation: Investigation;
  setRefetch: React.Dispatch<React.SetStateAction<boolean>>;
  setChangeTab: React.Dispatch<React.SetStateAction<string>>;
};

const Forward: FC<Props> = ({
  incident,
  investigation,
  setRefetch,
  setChangeTab,
}) => {
  const { t } = useTranslation();
  const { loginData } = useAuth();
  const { showTooltip } = useTooltip();
  const [isOpenForm, setIsOpenForm] = useState(false);
  const [actionIsLoading, setActionIsLoading] = useState(false);

  const isClerk = hasRole(loginData?.roles, [Roles.clerk]);

  const [furtherInvestigation, setFurtherInvestigation] = useState<
    FurtherInvestigation[]
  >([]);
  const [investigationFile, setInvestigationFile] = useState<
    InvestigationFile[]
  >([]);

  useEffect(() => {
    if (incident) {
      if (
        investigation?.CR_number !== undefined &&
        incident?.Incident_Registration_number !== undefined &&
        incident?.Incident_Registration_number !== null
      ) {
        fetchFurtherInvestigationFromCRandIncidentRegNo(
          investigation.CR_number,
          incident.Incident_Registration_number,
        )?.then((data) => {
          setFurtherInvestigation(data);
        });

        fetchInvestigationFileFromCRandIncidentRegNo(
          investigation.CR_number,
          incident.Incident_Registration_number,
        )?.then((data) => {
          setInvestigationFile(data);
        });
      }
    }
  }, [incident, investigation]);

  const handleCloseForm = (refetch = false) => {
    setIsOpenForm(false);
    if (refetch) {
      editCrimeReferences(incident?.uu_id, {
        // ...incident,
        status: "forwarded",
      })
        .then(() => {
          showTooltip(t("successfully_forwarded"), "success");
          setRefetch((prev) => !prev);
          setChangeTab("Investigation");
        })
        .catch((error) => {
          showTooltip(
            error?.response?.data?.detail ||
              errorHandlerOnForm(error) ||
              errorHandler(error) ||
              t("something_went_wrong_try_again"),
          );
        });
    }
  };

  return (
    <div className="min-w-[500px] bg-white rounded-xl px-4 pb-[22px] shadow-md">
      <div className="bg-[#AA232F] text-white px-4 py-2 inline-block rounded-b-[4px]">
        {t("forward_incident")}
      </div>
      <div className="grid grid-cols-1 gap-2">
        <div className="flex gap-3 items-center">
          <div className="">{CheckIcon}</div>
          <p className="text-[#929292]">{t("forward_incident_helper_text")}</p>
        </div>

        <div className="flex flex-row mt-4 gap-3">
          {incident?.status === "forwarded" ? (
            <div className="flex items-center gap-2">
              <div className="text-[#AA232F]">{CheckIcon}</div>
              <p className="text-[#AA232F]">{t("forwarded_to_coordinator")}</p>
            </div>
          ) : isClerk ? (
            <button
              className="border border-[#212121] bg-[#212121] px-[76px] py-3 text-white font-[Poppins] cursor-pointer font-[500] text-base rounded-md hover:bg-[#414040]"
              disabled={actionIsLoading}
              onClick={() => {
                // console.log(furtherInvestigation);
                // return;
                setActionIsLoading(true);
                editCrimeReferences2(incident?.uu_id, {
                  status: "forwarded",
                })
                  .then(() => {
                    if (
                      furtherInvestigation &&
                      furtherInvestigation?.length > 0
                    ) {
                      editFurtherInvestigation2({
                        id: furtherInvestigation[0]?.id,
                        decision: "back_to_prosecutor",
                      });
                    }
                    if (investigationFile && investigationFile?.length > 0) {
                      editReceivingInvestigationFile2({
                        id: investigationFile[0]?.id,
                        status: "assigned_to_prosecutor",
                      });
                    }

                    showTooltip(t("successfully_submitted"), "success");
                    setRefetch((prev) => !prev);
                    setActionIsLoading(false);
                  })
                  .catch((error) => {
                    showTooltip(
                      error?.response?.data?.detail ||
                        errorHandlerOnForm(error),
                      "error",
                    );
                    setActionIsLoading(false);
                  });
              }}
            >
              {actionIsLoading ? (
                <div className="flex items-center justify-center">
                  {LoadingIcon}
                  {t("loading")}
                </div>
              ) : (
                t("forward")
              )}
            </button>
          ) : (
            <input
              type="button"
              className="border border-[#212121] bg-[#212121] px-[76px] py-3 text-white font-[Poppins] cursor-pointer font-[500] text-base rounded-md hover:bg-[#414040]"
              value={t("forward_to_coordinator")}
              onClick={() => {
                setIsOpenForm(true);
              }}
            />
          )}
        </div>
      </div>
      <InvestigationFileForm
        action={"Add"}
        investigationFile={undefined}
        isOpen={isOpenForm}
        onClose={handleCloseForm}
        incident={incident}
        cr_number={investigation?.CR_number}
        isForward={true}
      />
    </div>
  );
};

export default Forward;
